(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcp-more-colour"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lcp-colour-products')) {
    customElements.define('lcp-colour-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.load();
      }
      async load() {
        const title = this.dataset.title.toLowerCase();
        const tags = JSON.parse(this.dataset.tags).map(tag => tag.toLowerCase());
        const explicit = tags.find(tag => /^(colour|color):[a-z0-9 -]+$/.test(tag));
        let words;
        if (explicit) {
          words = explicit.split(':')[1].trim().split(/[ -]+/);
        } else {
          const palette = /\b(black|white|red|pink|blue|navy|green|brown|beige|cream|grey|gray|purple|lavender|yellow|orange|burgundy|maroon|olive|gold|silver|ivory|champagne)\b/;
          const match = title.match(palette) || tags.join(' ').match(palette);
          if (!match) return;
          words = [match[1]];
          const print = title.match(/\b(gingham|check|checked|checkered|plaid|floral|stripe|striped)\b/);
          if (print) words.push(print[1]);
        }
        if (!words.length || words.length > 5) return;
        const terms = words.map(word => {
          const aliases = word === 'grey' || word === 'gray' ? ['grey','gray'] : ['check','checked','checkered'].includes(word) ? ['check','checked','checkered'] : word === 'stripe' || word === 'striped' ? ['stripe','striped'] : [word];
          return '(' + aliases.flatMap(value => ['title:' + value, 'tag:' + value]).join(' OR ') + ')';
        }).join(' AND ');
        const groupTag = 'colour:' + words.join('-');
        const query = '(' + terms + ') OR tag:"' + groupTag + '" OR tag:"' + groupTag.replace('colour:','color:') + '"';
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', query);
        url.searchParams.set('filter.v.availability', '1');
        url.searchParams.set('options[unavailable_products]', 'hide');
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        try {
          const response = await fetch(url);
          if (!response.ok || !this.isConnected) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const template = doc.querySelector('template[data-colour-results]');
          if (!template) return;
          const cards = [...template.content.querySelectorAll('.lcp-colour-card')].filter(card => card.dataset.productId !== this.dataset.productId).slice(0, Number(this.dataset.limit));
          if (!cards.length) return;
          const list = this.querySelector('.lcp-colour-list');
          cards.forEach(card => card.setAttribute('role','listitem'));
          list.replaceChildren(...cards);
          this.hidden = false;
          this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => list.scrollBy({left:Number(button.dataset.direction) * list.clientWidth})));
        } catch { this.hidden = true; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lcp-recently-viewed')) {
    customElements.define('lcp-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        const key = 'lcp_recently_viewed_v1';
        const now = Date.now();
        let previous;
        try {
          const stored = JSON.parse(localStorage.getItem(key) || '[]');
          const history = Array.isArray(stored) ? stored.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle) && Number.isFinite(item.at) && now - item.at < 30 * 24 * 60 * 60 * 1000) : [];
          previous = [...new Map(history.filter(item => item.handle !== this.dataset.handle).map(item => [item.handle,item])).values()];
          localStorage.setItem(key,JSON.stringify([{handle:this.dataset.handle,at:now},...previous].slice(0,20)));
        } catch { return; }
        if (!previous.length) return;
        this.load(previous.slice(0,Number(this.dataset.limit) || 8));
      }
      async load(history) {
        const root = this.dataset.rootUrl.replace(/\/?$/, '/');
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        const results = await Promise.allSettled(history.map(async item => {
          const url = new URL(root + 'products/' + item.handle,location.origin);
          url.searchParams.set('section_id','lcp-recently-viewed');
          if (previewTheme) url.searchParams.set('preview_theme_id',previewTheme);
          const response = await fetch(url);
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          return doc.querySelector('template[data-recent-product]')?.content.querySelector('.lcp-recent-card') || null;
        }));
        if (!this.isConnected) return;
        const cards = results.filter(result => result.status === 'fulfilled' && result.value).map(result => result.value);
        if (!cards.length) return;
        const list = this.querySelector('.lcp-recent-list');
        list.replaceChildren(...cards);
        this.hidden = false;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => list.scrollBy({left:Number(button.dataset.direction) * list.clientWidth})));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
